enum RealtimeAPIEventTypeEnum {
  ExportLicenseDataResultNotification = 'ExportLicenseDataResultNotification',
}

export default RealtimeAPIEventTypeEnum;
